export type GenericProductPotency = {
  unit: string;
  range: number[] | null;
};

export type GenericBrand = {
  name: string;
  image: string | null;
  description: string | null;
};

export enum GenericStrainType {
  oneToOne = '1 to 1',
  twoToOne = '2 to 1',
  fiveToOne = '5 to 1',
  tenToOne = '10 to 1',
  twentyToOne = '20 to 1',
  fiftyToOne = '50 to 1',
  highCbd = 'High CBD',
  hybrid = 'Hybrid',

  indica = 'Indica',

  indicaHybrid = 'Indica-Hybrid',
  nA = 'N/A',
  sativa = 'Sativa',
  sativaHybrid = 'Sativa-Hybrid',
  seed = 'Seed',
  thc = 'THC',
}

export enum GenericEffect {
  body = 'Body',
  calm = 'Calm',
  clearMind = 'Clear_Mind',
  comfort = 'Comfort',
  creative = 'Creative',
  energetic = 'Energetic',
  euphoric = 'Euphoric',
  focused = 'Focused',
  happy = 'Happy',
  inspired = 'Inspired',
  medicinal = 'Medicinal',
  mind = 'Mind',
  painRelief = 'Pain_Relief',
  relaxed = 'Relaxed',
  skinHealth = 'Skin_Health',
  sleepy = 'Sleepy',
  uplifted = 'Uplifted',
  joints = 'Joints',
  muscles = 'Muscles',
}

export type GenericPriceOption = {
  price: number;
  weight: string;
};
